module.exports = __webpack_public_path__ + "img/cayenne-gts-xray.b9598c8d.jpg";